import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const PREFIX = { brand: "brands", outfitter: "outfitters", guide: "guides", state: "states" };

function sessionId() {
  let s = localStorage.getItem("hr_sid");
  if (!s) { s = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("hr_sid", s); }
  return s;
}

/** /r/:code — server-side referral link. Records the click, stores attribution, then forwards. */
export default function ReferralRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    api.referralResolve(code, sessionId())
      .then((d) => {
        localStorage.setItem("hr_ref", JSON.stringify({ code, business_id: d.business_id, ts: Date.now() }));
        const path = d.public_path || `/${PREFIX[d.partner_type] || "brands"}/${d.slug}`;
        navigate(`${path}?ref=${code}&src=referral`, { replace: true });
      })
      .catch(() => navigate("/", { replace: true }));
  }, [code, navigate]);
  return (
    <div className="min-h-screen grid place-items-center bg-paper" data-testid="referral-redirect">
      <div className="text-center text-charcoal/60"><Loader2 className="animate-spin mx-auto text-forest" /><p className="mt-3 text-sm">Taking you there…</p></div>
    </div>
  );
}
